import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styles from './PageHeader.module.scss';
import cx from 'classnames';

interface PageHeaderProps {
	title?: string;
	subtitle?: string;
	children?: JSX.Element | JSX.Element[] | null;
	className?: string;
}

const PageHeader: FC<PageHeaderProps> = ({ title, subtitle, children, className }): JSX.Element => {
	return (
		<section className={cx(styles.PageHeader, className)}>
			{title && (
				<div>
					<h4 className={styles.Title}>{title}</h4>
					{subtitle && <p className={styles.Subtitle}>{subtitle}</p>}
				</div>
			)}
			{children && <section className={`${styles.Children} ${!title ? styles.FullWidth : ''}`}>{children}</section>}
		</section>
	);
};

PageHeader.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
};

export { PageHeader };
